import { blobToBase64 } from "../utils/helpers/blobToBase64";
import { CACHE_TTL } from "./cacheConfig";
import { jumboMediaAPI } from "./service";

export const imageAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getLogoImage: build.query({
            query: (body) => ({
                url: `/api/Clients/LogoImage/${body.id}${body.shareToken ? `?shareToken=${encodeURIComponent(body.shareToken)}` : ''}`,
                responseHandler: (response) => {
                    return response.blob().then(blob => blobToBase64(blob))
                }
            }),
            // Client logos are the definition of stable reference data, but this endpoint declared no
            // keepUnusedDataFor, so it inherited the global default of 0 (service.ts) and every entry
            // was evicted the moment its <BroadcasterLogo> unmounted. Result: 4 image requests + 4
            // CORS preflights on EVERY navigation between /campaigns and /deliveries, re-downloading
            // images that never change. Spec 34 D2.
            //
            // The 'Clients' tag is what makes the TTL safe: a client edit (updateClient, which uploads
            // BroadcasterLogoImage/ClockLogoImage) already invalidates it, so an updated logo appears
            // at once instead of after the TTL.
            providesTags: ["Clients"],
            keepUnusedDataFor: CACHE_TTL.REFERENCE,
        }),
    }),
});

export const {
    useGetLogoImageQuery,
    useLazyGetLogoImageQuery,
} = imageAPI;